'use client';

import { useEffect } from 'react';

import { useReportEmailClickMutation } from '@/redux/email-click/email-click.api';
import { logQueryError } from '@/redux/log-query-error';

export const EMAIL_CLICK_PARAM = 'ih_email';
const CATEGORY_RE = /^[a-z_]{1,40}$/;

export default function EmailClickReporter() {
  const [reportEmailClick] = useReportEmailClickMutation();

  useEffect(() => {
    const url = new URL(window.location.href);
    const category = url.searchParams.get(EMAIL_CLICK_PARAM);
    if (category === null) return;

    url.searchParams.delete(EMAIL_CLICK_PARAM);
    window.history.replaceState(
      window.history.state,
      '',
      `${url.pathname}${url.search}${url.hash}`
    );

    if (!CATEGORY_RE.test(category)) return;
    reportEmailClick({ category, path: url.pathname })
      .unwrap()
      .catch((err) => logQueryError('email click report failed', err));
  }, [reportEmailClick]);

  return null;
}
